import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Ghost move flag.
 *
 * @remarks
 * System-managed flag set when a move is created from Super Dispatch with a
 * placeholder vehicle (Make/Model = "Make Model"). Ghost moves require full
 * VIN capture in the driver workflow.
 */
export const schema = z.boolean().optional();

export type IsGhost = z.infer<typeof schema>;

export const definition = define({
  key: 'isGhost',
  schema,
  label: 'Is Ghost',
  description:
    'Marks a placeholder move requiring full VIN capture. Set when created from Super Dispatch with shell vehicle data. Not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
